import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from './SEO';
import { seoData } from './seo.config';
import { Helmet } from 'react-helmet';


const FindLawyer = () => {
  const lawyers = [
    {
      country: "Argentina",
      name: "Pablo A. Palazzi",
      lawfirm: "Allende & Brea",
      contact: "https://allende.com/en/?utm_source=deepfakehelp.com"
    },
    {
      country: "Australia",
      name: "Alex Cao",
      lawfirm: "Brightstone Defence",
      contact: "https://www.brightstonelegal.com.au/news/nsw-laws-ai-deepfakes-image-based-abuse/?utm_source=deepfakehelp.com"
    },
    {
      country: "Australia",
      name: "HSF Kramer team",
      lawfirm: "HSF Kramer Lawyers",
      contact: "https://www.hsfkramer.com/contact?utm_source=deepfakehelp.com"
    },
    {
      country: "Brazil",
      name: "Jonatas Lucena",
      lawfirm: "Jonatas Lucena Sociedade Individual de Advocacia",
      contact: "https://drjonatas.com.br/advogado-especialista-em-deepfake?utm_source=deepfakehelp.com"
    },
    {
      country: "Brazil",
      name: "Jonatas Lucena",
      lawfirm: "Jonatas Lucena Advogado",
      contact: "https://drjonatas.com.br?utm_source=deepfakehelp.com"
    },
    {
      country: "Canada",
      name: "Danielle Robitaille",
      lawfirm: "Henein Hutchison Robitaille LLP",
      contact: "https://hhllp.ca/?utm_source=deepfakehelp.com"
    },
    {
      country: "Canada",
      name: "Ullaw.ca team",
      lawfirm: "Ullaw Canada (Canada‑based legal‑news platform; contact via site)",
      contact: "https://www.ullaw.ca/contact?utm_source=deepfakehelp.com"
    },
    {
      country: "Germany",
      name: "Schlun & Elseven Rechtsanwälte team",
      lawfirm: "Schlun & Elseven Rechtsanwälte (deepfake lawyer services in Germany)",
      contact: "https://se-legal.de/contact?utm_source=deepfakehelp.com"
    },
    {
      country: "Greece",
      name: "Marianna Tsiare",
      lawfirm: "Ratio Legal Services",
      contact: "https://ratiolegal.services/blog/?utm_source=deepfakehelp.com"
    },
    {
      country: "Hong Kong",
      name: "Zhijing Yu",
      lawfirm: "Cooley LLP",
      contact: "https://www.cooley.com/news/coverage/2024/2024-02-23-hong-kong-firms-25-6-million-deepfake-scam-raises-alarm-to-improve-fraud-control?utm_source=deepfakehelp.com"
    },
    {
      country: "India",
      name: "Manisha Singh",
      lawfirm: "LexOrbis",
      contact: "https://www.lexorbis.com?utm_source=deepfakehelp.com"
    },
    {
      country: "India",
      name: "Krish Arya",
      lawfirm: "Khurana & Khurana, Advocates and IP Attorneys",
      contact: "https://www.khuranaandkhurana.com/contact-us?utm_source=deepfakehelp.com"
    },
    {
      country: "India",
      name: "Manisha Singh",
      lawfirm: "LexOrbis (deepfake/AI‑fraud legal‑response practice)",
      contact: "https://www.lexorbis.com/contact-us?utm_source=deepfakehelp.com"
    },
    {
      country: "India",
      name: "Kuber Law Firm team",
      lawfirm: "Kuber Law Firm (Legal defence in deepfake & AI‑based scams blog + contact)",
      contact: "https://kuberlawfirm.com/contact-us?utm_source=deepfakehelp.com"
    },
    {
      country: "Japan",
      name: "Atsushi Okada",
      lawfirm: "Mori Hamada & Matsumoto",
      contact: "https://www.morihamada.com/ja/notices/126191?utm_source=deepfakehelp.com"
    },
    {
      country: "Mainland China",
      name: "Richard McMorris",
      lawfirm: "Bird & Bird",
      contact: "https://www.twobirds.com/en/capabilities/artificial-intelligence/ai-legal-services?utm_source=deepfakehelp.com"
    },
    {
      country: "Malaysia",
      name: "Foong Cheng Leong",
      lawfirm: "Messrs Foong Cheng Leong & Co.",
      contact: "http://foongchengleong.com/wp?utm_source=deepfakehelp.com"
    },
    {
      country: "Malaysia",
      name: "LH Low & Associates",
      lawfirm: "LH Low & Associates",
      contact: "https://www.lhlow.com.my/contact-us?utm_source=deepfakehelp.com"
    },
    {
      country: "South Korea",
      name: "Keun Woo Lee",
      lawfirm: "Yoon & Yang LLC",
      contact: "https://www.yoonyang.com/eng/professionals/profile/201?utm_source=deepfakehelp.com"
    },
    {
      country: "South Korea",
      name: "Park Dong-il",
      lawfirm: "Daeryun Law Firm",
      contact: "https://www.daeryunlaw.com/success_new/2947?utm_source=deepfakehelp.com"
    },
    {
      country: "Spain",
      name: "Alejandro Seoane Pedreira",
      lawfirm: "Alejandro Seoane Pedreira (Boutique Penal)",
      contact: "https://seoanepedreira.com/inteligencia-artificial/deepfakes/?utm_source=deepfakehelp.com"
    },
    {
      country: "Spain",
      name: "Carlos R. C.",
      lawfirm: "Carlos C. R. Martínez (Soler Martín Abogados)",
      contact: "https://solermartinabogados.com/contacto?utm_source=deepfakehelp.com"
    },
    {
      country: "United Kingdom",
      name: "Toby Bond",
      lawfirm: "Bird & Bird",
      contact: "https://www.twobirds.com/en/capabilities/artificial-intelligence/ai-legal-services?utm_source=deepfakehelp.com"
    },
    {
      country: "United Kingdom",
      name: "Lockton Global (risk advice)",
      lawfirm: "Lockton Global (Risk‑advice for solicitors on deepfake‑enabled fraud)",
      contact: "https://global.lockton.com/contact?utm_source=deepfakehelp.com"
    },
    {
      country: "USA",
      name: "Steve Vondran",
      lawfirm: "Vondran Legal",
      contact: "https://www.vondranlegal.com/deep-fake-litigation?utm_source=deepfakehelp.com"
    },
    {
      country: "USA",
      name: "Salar Atrizadeh",
      lawfirm: "Atrizadeh Law (AI and deepfake practice)",
      contact: "https://www.atrizadeh.com/contact-us?utm_source=deepfakehelp.com"
    },
    {
      country: "USA",
      name: "C.A. Goldberg",
      lawfirm: "C.A. Goldberg, PLLC (Deepfakes & AI practice)",
      contact: "https://www.cagoldberglaw.com/contact?utm_source=deepfakehelp.com"
    }
  ];

  return (
    <>
  <Helmet>
        <link rel="canonical" href="https://deepfakehelp.com/deepfake-lawyers" />
      </Helmet>

      <SEO {...seoData.lawyers} 
      
      ogImage="/default-og-image.png"
      title={seoData.lawyers.title}
      description={seoData.lawyers.description}
      />
    <div className="min-h-screen bg-slate-50">
      <main className="container mx-auto px-4 py-12 max-w-6xl">
        <section>
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-slate-900 tracking-tight">
              Expert Deepfake Attorneys & Legal Firms
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Find specialized legal assistance to help you remove harmful content and protect your digital identity across the globe.
            </p>
          </div>

          <div className="block md:hidden space-y-6">
            {lawyers.map((lawyer, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start mb-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    {lawyer.country}
                  </span>
                </div>
                <div className="mb-1 text-lg font-bold text-slate-900">{lawyer.name}</div>
                <div className="mb-4 text-slate-600 italic text-sm">{lawyer.lawfirm}</div>
                <div className="mt-6">
                  <a 
                    href={lawyer.contact}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-colors shadow-sm"
                  >
                    Contact Professional
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="hidden md:block overflow-hidden bg-white rounded-2xl shadow-xl border border-slate-200">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="bg-slate-900 text-white">
                    <th className="p-5 font-semibold text-sm uppercase tracking-wider">Country</th>
                    <th className="p-5 font-semibold text-sm uppercase tracking-wider">Name</th>
                    <th className="p-5 font-semibold text-sm uppercase tracking-wider">Law Firm</th>
                    <th className="p-5 font-semibold text-sm uppercase tracking-wider text-right">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {lawyers.map((lawyer, index) => (
                    <tr key={index} className="hover:bg-slate-50 transition-colors group">
                      <td className="p-5">
                        <span className="font-medium text-slate-900">{lawyer.country}</span>
                      </td>
                      <td className="p-5">
                        <span className="text-slate-700">{lawyer.name}</span>
                      </td>
                      <td className="p-5">
                        <span className="text-slate-500 text-sm">{lawyer.lawfirm}</span>
                      </td>
                      <td className="p-5 text-right">
                        <a 
                          href={lawyer.contact}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg text-sm transition-all shadow-sm hover:shadow group-hover:scale-105"
                        >
                          Contact Now
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          
          <div className="mt-12 p-8 bg-blue-50 rounded-2xl border border-blue-100 text-center">
            <h3 className="text-xl font-bold text-blue-900 mb-2">Legal Professional?</h3>
            <p className="text-blue-700 mb-6">If you offer specialized services in deepfake litigation and would like to be listed here, please contact us.</p>
            <Link to="/contact" className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-800 underline">
              Apply to be listed
            </Link>
          </div>
        </section>
      </main>
    </div>
    </>
  );
};

export default FindLawyer;
